function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}
module.exports = _complement;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_complement.js
// module id = 4206
// module chunks = 168707334958949